export default require("./node_modules/dayjs/dayjs.min.js");